import React from "react";
import { useNavigate } from "react-router-dom";

function UnAuthAssessmentPopup({ setUnAuthPopup, errMsg, closingWindowFlag }) {
  const navigate = useNavigate()
  const handleRouteFunc = () => {
    const routes = localStorage.getItem("summarySideMenu");
    switch (routes) {
      case "Summary":
        navigate("/Summary")
        break;
      case "Assessment":
        navigate("/Assessment")
        break;
      default:
        navigate("/Assessment")
    }
  }

  return (
    <div className="ContainerSubmitedSucess ">
      <div className="SubContainerSubmitedSucess">
        <div className="d-flex justify-content-center align-items-center">
          <img src="/images/alert.svg" alt="" />
        </div>
        <div className="d-flex justify-content-center align-items-center mt-4 sucessMsg20">
          {errMsg}
        </div>
        <div className="d-flex justify-content-around align-items-center mt-5 widthOfContainer">
          <button
            className="okayBtnsucess"
            onClick={() => {
              setUnAuthPopup(false);
              if (!closingWindowFlag) {
                handleRouteFunc()
              }
            }}
          >
            Okay
          </button>
        </div>
      </div>
    </div>
  );
}

export default UnAuthAssessmentPopup;
